const HyperboleIcon = /*#__PURE__*/ [
  ["path", { d: "M2 12H22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 22L12 2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 8C18.2386 8 16 5.76142 16 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 16C5.76142 16 8 18.2386 8 21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export { HyperboleIcon as default };
//# sourceMappingURL=HyperboleIcon.js.map
